!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("@eg-maps/core")) : "function" == typeof define && define.amd ? define(["@eg-maps/core"], t) : "object" == typeof exports ? exports.egmapsGoogleMaps = t(require("@eg-maps/core")) : e.egmapsGoogleMaps = t(e["@eg-maps/core"]);
}("undefined" != typeof window ? window : global, function (e) {
  return function () {
    "use strict";

    var t = {
        518: function (t) {
          t.exports = e;
        }
      },
      i = {};
    function n(e) {
      var r = i[e];
      if (void 0 !== r) return r.exports;
      var s = i[e] = {
        exports: {}
      };
      return t[e](s, s.exports, n), s.exports;
    }
    n.d = function (e, t) {
      for (var i in t) n.o(t, i) && !n.o(e, i) && Object.defineProperty(e, i, {
        enumerable: !0,
        get: t[i]
      });
    }, n.g = function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    }(), n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var r = {};
    n.r(r), n.d(r, {
      GMaps: function () {
        return V;
      }
    });
    var s = {};
    n.r(s), n.d(s, {
      GooglePlaceContentProvider: function () {
        return W;
      },
      identifyGooglePlaceId: function () {
        return G;
      }
    });
    var o,
      a = n(518),
      l = Object.freeze({
        Linear: Object.freeze({
          None: function (e) {
            return e;
          },
          In: function (e) {
            return this.None(e);
          },
          Out: function (e) {
            return this.None(e);
          },
          InOut: function (e) {
            return this.None(e);
          }
        }),
        Quadratic: Object.freeze({
          In: function (e) {
            return e * e;
          },
          Out: function (e) {
            return e * (2 - e);
          },
          InOut: function (e) {
            return (e *= 2) < 1 ? .5 * e * e : -.5 * (--e * (e - 2) - 1);
          }
        }),
        Cubic: Object.freeze({
          In: function (e) {
            return e * e * e;
          },
          Out: function (e) {
            return --e * e * e + 1;
          },
          InOut: function (e) {
            return (e *= 2) < 1 ? .5 * e * e * e : .5 * ((e -= 2) * e * e + 2);
          }
        }),
        Quartic: Object.freeze({
          In: function (e) {
            return e * e * e * e;
          },
          Out: function (e) {
            return 1 - --e * e * e * e;
          },
          InOut: function (e) {
            return (e *= 2) < 1 ? .5 * e * e * e * e : -.5 * ((e -= 2) * e * e * e - 2);
          }
        }),
        Quintic: Object.freeze({
          In: function (e) {
            return e * e * e * e * e;
          },
          Out: function (e) {
            return --e * e * e * e * e + 1;
          },
          InOut: function (e) {
            return (e *= 2) < 1 ? .5 * e * e * e * e * e : .5 * ((e -= 2) * e * e * e * e + 2);
          }
        }),
        Sinusoidal: Object.freeze({
          In: function (e) {
            return 1 - Math.sin((1 - e) * Math.PI / 2);
          },
          Out: function (e) {
            return Math.sin(e * Math.PI / 2);
          },
          InOut: function (e) {
            return .5 * (1 - Math.sin(Math.PI * (.5 - e)));
          }
        }),
        Exponential: Object.freeze({
          In: function (e) {
            return 0 === e ? 0 : Math.pow(1024, e - 1);
          },
          Out: function (e) {
            return 1 === e ? 1 : 1 - Math.pow(2, -10 * e);
          },
          InOut: function (e) {
            return 0 === e ? 0 : 1 === e ? 1 : (e *= 2) < 1 ? .5 * Math.pow(1024, e - 1) : .5 * (2 - Math.pow(2, -10 * (e - 1)));
          }
        }),
        Circular: Object.freeze({
          In: function (e) {
            return 1 - Math.sqrt(1 - e * e);
          },
          Out: function (e) {
            return Math.sqrt(1 - --e * e);
          },
          InOut: function (e) {
            return (e *= 2) < 1 ? -.5 * (Math.sqrt(1 - e * e) - 1) : .5 * (Math.sqrt(1 - (e -= 2) * e) + 1);
          }
        }),
        Elastic: Object.freeze({
          In: function (e) {
            return 0 === e ? 0 : 1 === e ? 1 : -Math.pow(2, 10 * (e - 1)) * Math.sin(5 * (e - 1.1) * Math.PI);
          },
          Out: function (e) {
            return 0 === e ? 0 : 1 === e ? 1 : Math.pow(2, -10 * e) * Math.sin(5 * (e - .1) * Math.PI) + 1;
          },
          InOut: function (e) {
            return 0 === e ? 0 : 1 === e ? 1 : (e *= 2) < 1 ? -.5 * Math.pow(2, 10 * (e - 1)) * Math.sin(5 * (e - 1.1) * Math.PI) : .5 * Math.pow(2, -10 * (e - 1)) * Math.sin(5 * (e - 1.1) * Math.PI) + 1;
          }
        }),
        Back: Object.freeze({
          In: function (e) {
            var t = 1.70158;
            return 1 === e ? 1 : e * e * ((t + 1) * e - t);
          },
          Out: function (e) {
            var t = 1.70158;
            return 0 === e ? 0 : --e * e * ((t + 1) * e + t) + 1;
          },
          InOut: function (e) {
            var t = 2.5949095;
            return (e *= 2) < 1 ? e * e * ((t + 1) * e - t) * .5 : .5 * ((e -= 2) * e * ((t + 1) * e + t) + 2);
          }
        }),
        Bounce: Object.freeze({
          In: function (e) {
            return 1 - l.Bounce.Out(1 - e);
          },
          Out: function (e) {
            return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + .75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + .9375 : 7.5625 * (e -= 2.625 / 2.75) * e + .984375;
          },
          InOut: function (e) {
            return e < .5 ? .5 * l.Bounce.In(2 * e) : .5 * l.Bounce.Out(2 * e - 1) + .5;
          }
        }),
        generatePow: function (e) {
          return void 0 === e && (e = 4), e = (e = e < Number.EPSILON ? Number.EPSILON : e) > 1e4 ? 1e4 : e, {
            In: function (t) {
              return Math.pow(t, e);
            },
            Out: function (t) {
              return 1 - Math.pow(1 - t, e);
            },
            InOut: function (t) {
              return t < .5 ? Math.pow(2 * t, e) / 2 : (1 - Math.pow(2 - 2 * t, e)) / 2 + .5;
            }
          };
        }
      }),
      h = function () {
        return performance.now();
      },
      d = function () {
        function e() {
          this._tweens = {}, this._tweensAddedDuringUpdate = {};
        }
        return e.prototype.getAll = function () {
          var e = this;
          return Object.keys(this._tweens).map(function (t) {
            return e._tweens[t];
          });
        }, e.prototype.removeAll = function () {
          this._tweens = {};
        }, e.prototype.add = function (e) {
          this._tweens[e.getId()] = e, this._tweensAddedDuringUpdate[e.getId()] = e;
        }, e.prototype.remove = function (e) {
          delete this._tweens[e.getId()], delete this._tweensAddedDuringUpdate[e.getId()];
        }, e.prototype.update = function (e, t) {
          void 0 === e && (e = h()), void 0 === t && (t = !1);
          var i = Object.keys(this._tweens);
          if (0 === i.length) return !1;
          for (; i.length > 0;) {
            this._tweensAddedDuringUpdate = {};
            for (var n = 0; n < i.length; n++) {
              var r = this._tweens[i[n]],
                s = !t;
              r && !1 === r.update(e, s) && !t && delete this._tweens[i[n]];
            }
            i = Object.keys(this._tweensAddedDuringUpdate);
          }
          return !0;
        }, e;
      }(),
      u = {
        Linear: function (e, t) {
          var i = e.length - 1,
            n = i * t,
            r = Math.floor(n),
            s = u.Utils.Linear;
          return t < 0 ? s(e[0], e[1], n) : t > 1 ? s(e[i], e[i - 1], i - n) : s(e[r], e[r + 1 > i ? i : r + 1], n - r);
        },
        Bezier: function (e, t) {
          for (var i = 0, n = e.length - 1, r = Math.pow, s = u.Utils.Bernstein, o = 0; o <= n; o++) i += r(1 - t, n - o) * r(t, o) * e[o] * s(n, o);
          return i;
        },
        CatmullRom: function (e, t) {
          var i = e.length - 1,
            n = i * t,
            r = Math.floor(n),
            s = u.Utils.CatmullRom;
          return e[0] === e[i] ? (t < 0 && (r = Math.floor(n = i * (1 + t))), s(e[(r - 1 + i) % i], e[r], e[(r + 1) % i], e[(r + 2) % i], n - r)) : t < 0 ? e[0] - (s(e[0], e[0], e[1], e[1], -n) - e[0]) : t > 1 ? e[i] - (s(e[i], e[i], e[i - 1], e[i - 1], n - i) - e[i]) : s(e[r ? r - 1 : 0], e[r], e[i < r + 1 ? i : r + 1], e[i < r + 2 ? i : r + 2], n - r);
        },
        Utils: {
          Linear: function (e, t, i) {
            return (t - e) * i + e;
          },
          Bernstein: function (e, t) {
            var i = u.Utils.Factorial;
            return i(e) / i(t) / i(e - t);
          },
          Factorial: (o = [1], function (e) {
            var t = 1;
            if (o[e]) return o[e];
            for (var i = e; i > 1; i--) t *= i;
            return o[e] = t, t;
          }),
          CatmullRom: function (e, t, i, n, r) {
            var s = .5 * (i - e),
              o = .5 * (n - t),
              a = r * r;
            return (2 * t - 2 * i + s + o) * (r * a) + (-3 * t + 3 * i - 2 * s - o) * a + s * r + t;
          }
        }
      },
      c = function () {
        function e() {}
        return e.nextId = function () {
          return e._nextId++;
        }, e._nextId = 0, e;
      }(),
      p = new d(),
      g = function () {
        function e(e, t) {
          void 0 === t && (t = p), this._object = e, this._group = t, this._isPaused = !1, this._pauseStart = 0, this._valuesStart = {}, this._valuesEnd = {}, this._valuesStartRepeat = {}, this._duration = 1e3, this._isDynamic = !1, this._initialRepeat = 0, this._repeat = 0, this._yoyo = !1, this._isPlaying = !1, this._reversed = !1, this._delayTime = 0, this._startTime = 0, this._easingFunction = l.Linear.None, this._interpolationFunction = u.Linear, this._chainedTweens = [], this._onStartCallbackFired = !1, this._onEveryStartCallbackFired = !1, this._id = c.nextId(), this._isChainStopped = !1, this._propertiesAreSetUp = !1, this._goToEnd = !1;
        }
        return e.prototype.getId = function () {
          return this._id;
        }, e.prototype.isPlaying = function () {
          return this._isPlaying;
        }, e.prototype.isPaused = function () {
          return this._isPaused;
        }, e.prototype.getDuration = function () {
          return this._duration;
        }, e.prototype.to = function (e, t) {
          if (void 0 === t && (t = 1e3), this._isPlaying) throw new Error("Can not call Tween.to() while Tween is already started or paused. Stop the Tween first.");
          return this._valuesEnd = e, this._propertiesAreSetUp = !1, this._duration = t < 0 ? 0 : t, this;
        }, e.prototype.duration = function (e) {
          return void 0 === e && (e = 1e3), this._duration = e < 0 ? 0 : e, this;
        }, e.prototype.dynamic = function (e) {
          return void 0 === e && (e = !1), this._isDynamic = e, this;
        }, e.prototype.start = function (e, t) {
          if (void 0 === e && (e = h()), void 0 === t && (t = !1), this._isPlaying) return this;
          if (this._group && this._group.add(this), this._repeat = this._initialRepeat, this._reversed) for (var i in this._reversed = !1, this._valuesStartRepeat) this._swapEndStartRepeatValues(i), this._valuesStart[i] = this._valuesStartRepeat[i];
          if (this._isPlaying = !0, this._isPaused = !1, this._onStartCallbackFired = !1, this._onEveryStartCallbackFired = !1, this._isChainStopped = !1, this._startTime = e, this._startTime += this._delayTime, !this._propertiesAreSetUp || t) {
            if (this._propertiesAreSetUp = !0, !this._isDynamic) {
              var n = {};
              for (var r in this._valuesEnd) n[r] = this._valuesEnd[r];
              this._valuesEnd = n;
            }
            this._setupProperties(this._object, this._valuesStart, this._valuesEnd, this._valuesStartRepeat, t);
          }
          return this;
        }, e.prototype.startFromCurrentValues = function (e) {
          return this.start(e, !0);
        }, e.prototype._setupProperties = function (e, t, i, n, r) {
          for (var s in i) {
            var o = e[s],
              a = Array.isArray(o),
              l = a ? "array" : typeof o,
              h = !a && Array.isArray(i[s]);
            if ("undefined" !== l && "function" !== l) {
              if (h) {
                if (0 === (v = i[s]).length) continue;
                for (var d = [o], u = 0, c = v.length; u < c; u += 1) {
                  var p = this._handleRelativeValue(o, v[u]);
                  if (isNaN(p)) {
                    h = !1, console.warn("Found invalid interpolation list. Skipping.");
                    break;
                  }
                  d.push(p);
                }
                h && (i[s] = d);
              }
              if ("object" !== l && !a || !o || h) (void 0 === t[s] || r) && (t[s] = o), a || (t[s] *= 1), n[s] = h ? i[s].slice().reverse() : t[s] || 0;else {
                t[s] = a ? [] : {};
                var g = o;
                for (var m in g) t[s][m] = g[m];
                n[s] = a ? [] : {};
                var v = i[s];
                if (!this._isDynamic) {
                  var f = {};
                  for (var m in v) f[m] = v[m];
                  i[s] = v = f;
                }
                this._setupProperties(g, t[s], v, n[s], r);
              }
            }
          }
        }, e.prototype.stop = function () {
          return this._isChainStopped || (this._isChainStopped = !0, this.stopChainedTweens()), this._isPlaying ? (this._group && this._group.remove(this), this._isPlaying = !1, this._isPaused = !1, this._onStopCallback && this._onStopCallback(this._object), this) : this;
        }, e.prototype.end = function () {
          return this._goToEnd = !0, this.update(1 / 0), this;
        }, e.prototype.pause = function (e) {
          return void 0 === e && (e = h()), this._isPaused || !this._isPlaying || (this._isPaused = !0, this._pauseStart = e, this._group && this._group.remove(this)), this;
        }, e.prototype.resume = function (e) {
          return void 0 === e && (e = h()), this._isPaused && this._isPlaying ? (this._isPaused = !1, this._startTime += e - this._pauseStart, this._pauseStart = 0, this._group && this._group.add(this), this) : this;
        }, e.prototype.stopChainedTweens = function () {
          for (var e = 0, t = this._chainedTweens.length; e < t; e++) this._chainedTweens[e].stop();
          return this;
        }, e.prototype.group = function (e) {
          return void 0 === e && (e = p), this._group = e, this;
        }, e.prototype.delay = function (e) {
          return void 0 === e && (e = 0), this._delayTime = e, this;
        }, e.prototype.repeat = function (e) {
          return void 0 === e && (e = 0), this._initialRepeat = e, this._repeat = e, this;
        }, e.prototype.repeatDelay = function (e) {
          return this._repeatDelayTime = e, this;
        }, e.prototype.yoyo = function (e) {
          return void 0 === e && (e = !1), this._yoyo = e, this;
        }, e.prototype.easing = function (e) {
          return void 0 === e && (e = l.Linear.None), this._easingFunction = e, this;
        }, e.prototype.interpolation = function (e) {
          return void 0 === e && (e = u.Linear), this._interpolationFunction = e, this;
        }, e.prototype.chain = function () {
          for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
          return this._chainedTweens = e, this;
        }, e.prototype.onStart = function (e) {
          return this._onStartCallback = e, this;
        }, e.prototype.onEveryStart = function (e) {
          return this._onEveryStartCallback = e, this;
        }, e.prototype.onUpdate = function (e) {
          return this._onUpdateCallback = e, this;
        }, e.prototype.onRepeat = function (e) {
          return this._onRepeatCallback = e, this;
        }, e.prototype.onComplete = function (e) {
          return this._onCompleteCallback = e, this;
        }, e.prototype.onStop = function (e) {
          return this._onStopCallback = e, this;
        }, e.prototype.update = function (e, t) {
          var i,
            n,
            r = this;
          if (void 0 === e && (e = h()), void 0 === t && (t = !0), this._isPaused) return !0;
          var s = this._startTime + this._duration;
          if (!this._goToEnd && !this._isPlaying) {
            if (e > s) return !1;
            t && this.start(e, !0);
          }
          if (this._goToEnd = !1, e < this._startTime) return !0;
          !1 === this._onStartCallbackFired && (this._onStartCallback && this._onStartCallback(this._object), this._onStartCallbackFired = !0), !1 === this._onEveryStartCallbackFired && (this._onEveryStartCallback && this._onEveryStartCallback(this._object), this._onEveryStartCallbackFired = !0);
          var o = e - this._startTime,
            a = this._duration + (null !== (i = this._repeatDelayTime) && void 0 !== i ? i : this._delayTime),
            l = this._duration + this._repeat * a,
            d = function () {
              if (0 === r._duration) return 1;
              if (o > l) return 1;
              var e = Math.trunc(o / a),
                t = o - e * a,
                i = Math.min(t / r._duration, 1);
              return 0 === i && o === r._duration ? 1 : i;
            }(),
            u = this._easingFunction(d);
          if (this._updateProperties(this._object, this._valuesStart, this._valuesEnd, u), this._onUpdateCallback && this._onUpdateCallback(this._object, d), 0 === this._duration || o >= this._duration) {
            if (this._repeat > 0) {
              var c = Math.min(Math.trunc((o - this._duration) / a) + 1, this._repeat);
              for (n in isFinite(this._repeat) && (this._repeat -= c), this._valuesStartRepeat) this._yoyo || "string" != typeof this._valuesEnd[n] || (this._valuesStartRepeat[n] = this._valuesStartRepeat[n] + parseFloat(this._valuesEnd[n])), this._yoyo && this._swapEndStartRepeatValues(n), this._valuesStart[n] = this._valuesStartRepeat[n];
              return this._yoyo && (this._reversed = !this._reversed), this._startTime += a * c, this._onRepeatCallback && this._onRepeatCallback(this._object), this._onEveryStartCallbackFired = !1, !0;
            }
            this._onCompleteCallback && this._onCompleteCallback(this._object);
            for (var p = 0, g = this._chainedTweens.length; p < g; p++) this._chainedTweens[p].start(this._startTime + this._duration, !1);
            return this._isPlaying = !1, !1;
          }
          return !0;
        }, e.prototype._updateProperties = function (e, t, i, n) {
          for (var r in i) if (void 0 !== t[r]) {
            var s = t[r] || 0,
              o = i[r],
              a = Array.isArray(e[r]),
              l = Array.isArray(o);
            !a && l ? e[r] = this._interpolationFunction(o, n) : "object" == typeof o && o ? this._updateProperties(e[r], s, o, n) : "number" == typeof (o = this._handleRelativeValue(s, o)) && (e[r] = s + (o - s) * n);
          }
        }, e.prototype._handleRelativeValue = function (e, t) {
          return "string" != typeof t ? t : "+" === t.charAt(0) || "-" === t.charAt(0) ? e + parseFloat(t) : parseFloat(t);
        }, e.prototype._swapEndStartRepeatValues = function (e) {
          var t = this._valuesStartRepeat[e],
            i = this._valuesEnd[e];
          this._valuesStartRepeat[e] = "string" == typeof i ? this._valuesStartRepeat[e] + parseFloat(i) : this._valuesEnd[e], this._valuesEnd[e] = t;
        }, e;
      }(),
      m = (c.nextId, p),
      v = (m.getAll.bind(m), m.removeAll.bind(m), m.add.bind(m), m.remove.bind(m), m.update.bind(m));
    const {
        firstDefinedValue: f,
        firstDefinedValueAndKey: y,
        firstDefinedKey: _
      } = a.Utils,
      {
        removeDuplicates: b,
        roundLatOrLng: M,
        roundLatLng: k,
        isArray: L,
        getPaddedZoomAndCenter: P,
        roundZoom: C
      } = a.Utils,
      {
        computeZoomFromBBox: w,
        addMeterToLat: O,
        convertGeoJsonPolygonToPath: E
      } = a.Geo,
      {
        createPinMarker: T,
        createTextMarker: A,
        createClusterMarker: S,
        createObfuscatedMarker: F,
        events: D,
        finalizeMarkerCreation: x,
        cleanMarkerListeners: I,
        setMarkerZIndex: j,
        registerCompListeners: B,
        switchHtmlAriaLabel: U
      } = a.MarkerUtils,
      N = 256,
      R = 256;
    class z extends a.TilesLoader {
      constructor(e, t, i, n, r, s) {
        super(e, t, i, n, r, s, 0), this.tileSize = new google.maps.Size(N, R), this.debugTileId = e.tiles.debugTileId;
      }
      getTile(e, t, i) {
        if (setTimeout(() => this.loadTile(e.x, e.y, t), 10), this.debugTileId) {
          const t = i.createElement("div");
          return t.innerHTML = String(e), t.style.width = this.tileSize.width + "px", t.style.height = this.tileSize.height + "px", t.style.fontSize = "10", t.style.borderStyle = "solid", t.style.borderWidth = "1px", t.style.borderColor = "#AAAAAA", t;
        }
      }
      unbindAll() {
        this.getPanes().overlayMouseTarget.removeAllChildren();
      }
    }
    const Z = {
      mapDragStart: "dragstart",
      mapDragEnd: "dragend",
      mapCenterChanged: "center_changed",
      mapBoundsChanged: "bounds_changed",
      mapZoomChanged: "zoom_changed",
      tilesLoaded: "tilesloaded",
      idle: "idle",
      mapTypeIdChanged: "maptypeid_changed"
    };
    class V extends a.BaseMap {
      constructor(e, t, i, n) {
        super(e, t, i, n), this.useAdvancedMarkers = (0, a.defaultConfig)().googleMaps.useAdvancedMarkers, this.logger = e.logger("GMaps"), this.logger.debug("GMaps constructor"), this.mapFocusListenersToRegister = [], this.visiblePolygonsByKey = new Map(), this.realmap = void 0, this.keyboardListeners = void 0;
      }
      _buildMapProviderOptions(e, t, i) {
        var n;
        const r = {
            keyboardShortcuts: !1,
            clickableIcons: e
          },
          s = null === (n = this.settings.googleMaps) || void 0 === n ? void 0 : n.gmapsAddConfig;
        return s && Object.assign(r, s), t && i && (r.zoom = t, r.center = {
          lat: i[0],
          lng: i[1]
        }), r;
      }
      updateMapProviderConfig() {
        var e;
        this.useAdvancedMarkers = this._shouldUseAdvancedMarker();
        const t = !0 === (null === (e = this.baseMapMarkersClickManagement) || void 0 === e ? void 0 : e.isEnabled());
        t && !this.baseMapMarkersClickManagement.isListenerRegistered() && this._registerBaseMapMarkerClickListener();
        const i = this._buildMapProviderOptions(t, this.realmap.getZoom(), this.getCenter());
        this.realmap.setOptions(i);
      }
      deleteMarker(e) {
        const t = e.marker;
        t && (t.advancedMarker ? t.setMap(null) : a.HtmlUtils.detachElement(t), t.debug && t.debug.setMap(null), this._clearObfuscateArea(t), I(t), delete e.marker);
      }
      _callbackWhenElementReattached() {
        const e = this;
        return new Promise(t => {
          setTimeout(() => {
            const {
              temporaryDiv: i
            } = e;
            e.temporaryDiv = void 0, e._reattachElementFromTemporaryDiv(i, e.customMarkerOverlay.getPanes().overlayMouseTarget), e._updateViewport(), t();
          }, 20);
        });
      }
      isUsingAdvancedMarker() {
        return this.useAdvancedMarkers;
      }
      _isAdvancedMarkerApiLoaded() {
        var e;
        return void 0 !== (null === (e = google) || void 0 === e || null === (e = e.maps) || void 0 === e || null === (e = e.marker) || void 0 === e ? void 0 : e.AdvancedMarkerElement);
      }
      _shouldUseAdvancedMarker() {
        const {
            debugShouldUseAdvancedMarkers: e,
            useAdvancedMarkers: t
          } = this.settings.googleMaps,
          i = e || t,
          n = Boolean(i && this._isAdvancedMarkerApiLoaded() && this.realmap.getMapCapabilities().isAdvancedMarkersAvailable);
        return this.logger.debug("Using " + (n ? "Google-maps advanced markers" : "HTML markers on Custom layout")), i && !n && this.logger.debug("Advanced markers not available and cannot be used"), n;
      }
      init(e, t) {
        var i, n;
        if (void 0 === this.node) return Promise.reject(new Error("Map container element not defined"));
        if (void 0 === (null === (i = a.HtmlUtils.globalObject().google) || void 0 === i || null === (i = i.maps) || void 0 === i ? void 0 : i.Map)) return Promise.reject(new Error("Google Maps API not loaded"));
        const r = this.addEventListener.bind(this),
          {
            zoom: s,
            center: o
          } = this._zoomAndCenterFromViewport(e, t) || {},
          l = this._buildMapProviderOptions(!0 === (null === (n = this.baseMapMarkersClickManagement) || void 0 === n ? void 0 : n.isEnabled()), s, o);
        this.node && (this.realmap = new google.maps.Map(this.node, l), this.useAdvancedMarkers = this._shouldUseAdvancedMarker()), this._initializeTilesOverlayMapType(), a.HtmlUtils.documentIsDefined() && (this.temporaryDiv = a.HtmlUtils.createDiv(this.uniqId("temporaryDiv")), this.clonesDivForMeasure = a.HtmlUtils.createDiv(this.uniqId("clonesDiv"), document.body, void 0, "position: absolute; top: -9999px; left: -9999px"));
        const h = this._createPopup.bind(this),
          d = this._registerKeyboardListeners.bind(this),
          u = this._registerMapListeners.bind(this),
          c = this._registerMapFocusListeners.bind(this),
          p = this._registerTilesLoadedListener.bind(this),
          g = this._updateViewport.bind(this);
        return this._initializeCustomMarkerOverlay(this.temporaryDiv, this._callbackWhenElementReattached.bind(this)).then(() => {
          this.mapNavFocusElement = this._findMapFocusElement(), this.mapNavFocusElement && (a.HtmlUtils.setTabIndex(this.mapNavFocusElement, 0), this.mapFocusListenersToRegister.forEach(e => {
            let {
              eventName: t,
              cb: i
            } = e;
            this.listenersToDeregister.push(r(this.mapNavFocusElement, t, i));
          })), this.popup = h(), d(), u(), c(), p(), g();
        }), this.configHelper.readParam("map,mapInitWaitForTiles") ? new Promise(e => r(this.realmap, Z.tilesLoaded, e, !0)) : Promise.resolve();
      }
      _findMapFocusElement() {
        if (this.node) return a.HtmlUtils.childrenAsArray(this.node).map(e => a.HtmlUtils.getFirstChildWithAriaRoleDescription(e, "map", !0)).filter(e => void 0 !== e)[0];
      }
      registerListenerOnMapFocusElement(e, t) {
        this.mapNavFocusElement ? this.listenersToDeregister.push(this.addEventListener(this.mapNavFocusElement, e, t)) : this.mapFocusListenersToRegister.push({
          eventName: e,
          cb: t
        });
      }
      _registerMapFocusListeners() {
        if (this.keyboardFeatures && this.mapNavFocusElement) {
          const e = () => this.keyboardFeatures.refreshKeyboardNavIconVisibility();
          this.listenersToDeregister.push(this.addEventListener(this.mapNavFocusElement, D.focus, e));
          const t = () => this.keyboardFeatures.refreshKeyboardNavIconVisibility(!1);
          this.listenersToDeregister.push(this.addEventListener(this.mapNavFocusElement, D.focusOut, t));
        }
      }
      _registerTilesLoadedListener() {
        this.listenersToDeregister.push(this.addEventListener(this.realmap, Z.tilesLoaded, () => this.handleTilesLoaded("mapProvider", "map")));
      }
      _initializeTilesOverlayMapType() {
        var e;
        this.tilesLoader = new z(this.settings, this.createTileFeature.bind(this), this.removeTileFeature.bind(this), this._updateViewport.bind(this), this.handleTilesLoaded.bind(this), this.handleTilesContentLoaded.bind(this)), null === (e = this.realmap) || void 0 === e || null === (e = e.overlayMapTypes) || void 0 === e || e.insertAt(0, this.tilesLoader);
      }
      _reattachElementFromTemporaryDiv(e, t) {
        if (e) {
          const {
            children: i
          } = e;
          for (let e = 0; e < ((null == i ? void 0 : i.length) || -1); e++) a.HtmlUtils.reattachElement(i[e], t);
        }
      }
      _initializeCustomMarkerOverlay(e, t) {
        const i = function (i, n, r, s, o) {
          this.onAdd = function () {
            const {
              overlayMouseTarget: i
            } = this.getPanes();
            s(e, i), a.HtmlUtils.setZIndex(i, google.maps.Marker.MAX_ZINDEX + 1), t(), o();
          }, this.setMap(i), this.onRemove = function () {
            r().forEach(e => {
              a.HtmlUtils.detachElement(e.popup);
            });
            for (let e of this.clusters) a.HtmlUtils.detachElement(e.marker);
          }, this.draw = function () {
            n();
          };
        };
        return i.prototype = new google.maps.OverlayView(), new Promise(e => {
          this.customMarkerOverlay = new i(this.realmap, this._updateMarkersPositionOnLayer.bind(this), this.features.all.bind(this), this._reattachElementFromTemporaryDiv.bind(this), e);
        });
      }
      getMarkerElement(e) {
        const t = e.marker;
        return null != t && t.advancedMarker ? t.content : t;
      }
      moveMarkerPosition(e, t) {
        const i = this.customMarkerOverlay.getProjection(),
          n = i.fromLatLngToDivPixel(new google.maps.LatLng(e.latLng[0], e.latLng[1])),
          r = {
            x: n.x + t.x,
            y: n.y + t.y
          },
          s = i.fromDivPixelToLatLng(r);
        e.latLng[0] = s.lat(), e.latLng[1] = s.lng(), e.computedLatLng = [s.lat(), s.lng()], e.marker && (e.marker.position = s), this._updateMarkerPositionOnLayer(e, i);
      }
      _updateViewport(e) {
        var t;
        return null !== (t = this.customMarkerOverlay) && void 0 !== t && null !== (t = t.getPanes()) && void 0 !== t && t.overlayMouseTarget ? super._updateViewport(e).then(e => (this._updateMarkersPositionOnLayer(), e)) : Promise.resolve(e);
      }
      getRectOfMarker(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        const i = this.customMarkerOverlay.getProjection(),
          n = e.computedLatLng && e.computedLatLng[0] ? e.computedLatLng[0] : e.latLng[0],
          r = e.computedLatLng && e.computedLatLng[1] ? e.computedLatLng[1] : e.latLng[1],
          s = i.fromLatLngToDivPixel(new google.maps.LatLng(n, r)),
          {
            width: o,
            height: l
          } = this._getMarkerDimensionsOnScreen(e);
        return a.HtmlUtils.getRect(s, o + 2 * t, l + 2 * t);
      }
      _getMarkerDimensionsOnScreen(e) {
        const t = e.marker;
        if (t.dimensions) return t.dimensions;
        {
          const i = this.getMarkerElement(e),
            {
              clientWidth: n,
              clientHeight: r
            } = i;
          let s = {
            width: n,
            height: r
          };
          if (0 === n || 0 === r) {
            const {
              width: e,
              height: t
            } = this.measureWidthAndHeight(i);
            s = {
              width: e,
              height: t
            };
          }
          return 0 === s.width && 0 === s.height || (t.dimensions = s), s;
        }
      }
      measureWidthAndHeight(e) {
        const t = e.cloneNode(!0);
        t.style.visibility = "hidden", t.style.position = "absolute", this.temporaryDiv, this.clonesDivForMeasure.appendChild(t);
        const {
          clientWidth: i,
          clientHeight: n
        } = t;
        return this.clonesDivForMeasure.removeChild(t), {
          width: i,
          height: n
        };
      }
      _updateMarkersPositionOnLayer(e) {
        if (this.customMarkerOverlay) {
          const {
              isAtLeastOnePropertyStatusUsingObfuscateMarker: t,
              isAtLeastOneProductStatusUsingObfuscateMarker: i,
              obfuscateRadiusInMeters: n
            } = this.settings,
            r = this.customMarkerOverlay.getProjection();
          if (r) {
            const s = e ? e.filter(e => e.marker) : this.features.all().filter(e => e.marker).concat(this.clusters || []);
            if (t || i) {
              const e = this.getCenter();
              Object.values(n).forEach(t => {
                const i = [M(O(e[0], 2 * t.radius)), e[1]];
                t.width = Math.round(this._fromLatLngToDivPixel(r, ...e).y - this._fromLatLngToDivPixel(r, ...i).y);
              });
            }
            s.forEach(e => this._updateMarkerPositionOnLayer(e, r)), this._updateMarkerPositionFromCollision(), this.updatePopupPositionOnLayer();
          }
        }
      }
      _updateMarkerPositionOnLayer(e, t) {
        if (!(null == e ? void 0 : e.marker).advancedMarker) {
          const i = this.getMarkerElement(e);
          if (t) {
            const n = t.fromLatLngToDivPixel(e.marker.position);
            if (n) {
              const e = 0,
                t = 0,
                r = "bottom";
              a.HtmlUtils.setPosition(i, n.x + e, n.y + t, r);
            }
          }
        }
      }
      _fromLatLngToDivPixel(e, t, i) {
        return null == e ? void 0 : e.fromLatLngToDivPixel(new google.maps.LatLng(t, i));
      }
      _fromDivPixelToLatLng(e, t, i) {
        return null == e ? void 0 : e.fromDivPixelToLatLng(new google.maps.Point(t, i));
      }
      updatePopupPositionOnLayer() {
        var e;
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 20;
        const {
          feature: i
        } = this.popup || {};
        if (null !== (e = this.customMarkerOverlay) && void 0 !== e && e.getProjection() && i && i.defined) {
          const {
              popupPositions: e
            } = this.settings,
            n = this._fromLatLngToDivPixel(this.customMarkerOverlay.getProjection(), ...i.latLng);
          let r, s, o;
          switch (f(e[i.type], i.hashKeys)) {
            case "above":
            default:
              r = 0, s = -26, o = "bottom";
              break;
            case "below":
              r = 0, s = 3, o = "top";
          }
          n && (t > 0 ? setTimeout(() => {
            a.HtmlUtils.setPosition(this.popup, n.x + r, n.y + s, o);
          }, 20) : a.HtmlUtils.setPosition(this.popup, n.x + r, n.y + s, o));
        }
      }
      ensurePopupVisibility() {
        const {
            popup: {
              feature: e,
              offsetWidth: t,
              offsetHeight: i
            },
            node: {
              offsetWidth: n,
              offsetHeight: r
            }
          } = this,
          s = f(this.configHelper.popupVisibilityPaddings()[e.type], e.hashKeys),
          o = null == s ? void 0 : s.x,
          a = null == s ? void 0 : s.y,
          {
            popupPositions: l
          } = this.settings,
          h = "below" === f(l[e.type], e.hashKeys),
          d = h ? 1 : -1,
          u = this.getRectOfMarker(e).height,
          c = this._fromLatLngToDivPixel(this.customMarkerOverlay.getProjection(), ...e.latLng);
        let p = {
          x: c.x + n / 2 - t / 2,
          y: c.y + u * d + r / 2 + i * d
        };
        const [g, m] = this._calculatePopupVisibilityOffsetValues(p, o, a, n, r, t, i, h);
        0 === g && 0 === m || this.realmap.panBy(g, m);
      }
      _ignoreMapClickEvent(e) {
        var t;
        return void 0 !== e.placeId && !0 === (null === (t = this.baseMapMarkersClickManagement) || void 0 === t ? void 0 : t.isEnabled());
      }
      _handleMapClick(e) {
        if (!this._ignoreMapClickEvent(e)) {
          const t = {
            position: {
              x: parseInt(e.pixel.x),
              y: parseInt(e.pixel.y)
            },
            latLng: {
              lat: M(e.latLng.lat()),
              lng: M(e.latLng.lng())
            }
          };
          this.handleMapClick(t);
        }
      }
      _registerMapListeners() {
        var e;
        this.lastCenterChecked = {
          centers: [this.getCenter()],
          events: []
        }, this.lastZoomValueChecked = [this.getZoom()], this.listenersToDeregister.push(...this._registerListenerForIdle()), this.listenersToDeregister.push(this._registerDragEndEventLogic()), this.listenersToDeregister.push(...this._registerZoomListener()), this.listenersToDeregister.push(...this._registerCenterChangedEventLogic()), this.listenersToDeregister.push(this.addEventListener(this.realmap, Z.mapDragStart, this.handleDragStart.bind(this))), this.listenersToDeregister.push(this.addEventListener(this.realmap, D.mapClick, this._handleMapClick.bind(this)));
        this.listenersToDeregister.push(this.addEventListener(this.realmap, Z.mapTypeIdChanged, (() => {
          this.eventsManager.pushEvent(a.EventTypes.mapTypeChanged, {
            mapTypeId: this.realmap.getMapTypeId()
          });
        }).bind(this))), !0 === (null === (e = this.baseMapMarkersClickManagement) || void 0 === e ? void 0 : e.isEnabled()) && this._registerBaseMapMarkerClickListener();
      }
      _registerBaseMapMarkerClickListener() {
        const e = this.addEventListener(this.realmap, D.mapClick, e => {
          e.placeId && (this.baseMapMarkersClickManagement.handleBaseMapMarkerClick(D.mapClick, e.placeId, {
            lat: e.latLng.lat(),
            lng: e.latLng.lng()
          }), this.stopPropagation(e));
        });
        this.baseMapMarkersClickManagement.registerBaseMapMarkerClickUnregisterListenerCallback(e);
      }
      _registerListenerForIdle() {
        this.idle = !0;
        const e = this;
        return [this.addEventListener(this.realmap, Z.idle, () => {
          e.idle = !0, e.eventsManager.pushEvent(a.EventTypes.idle);
        }), this.addEventListener(this.realmap, Z.mapBoundsChanged, () => e.idle = !1)];
      }
      _registerKeyboardListeners() {
        const e = this.getZoom.bind(this);
        this.keyboardListeners = new a.KeyboardListeners(e => this.realmap.panBy(...e), () => this.realmap.setZoom(e() + 1), () => this.realmap.setZoom(e() - 1)), this.registerListenerOnMapFocusElement(D.keyDown, this.keyboardListeners.keyDownListenerCallback), this.registerListenerOnMapFocusElement(D.keyUp, this.keyboardListeners.keyUpListenerCallback), this.registerListenerOnMapFocusElement(D.keyPress, this.keyboardListeners.keyPressListenerCallback);
      }
      _registerDragEndEventLogic() {
        return this.addEventListener(this.realmap, Z.mapDragEnd, () => {
          this.lastCenterChecked.events.push("drag");
        });
      }
      _registerCenterChangedEventLogic() {
        const {
            debouncingEventsTime: e
          } = this.settings.googleMaps,
          t = e.centerChanged;
        return [this.addEventListener(this.realmap, Z.mapCenterChanged, () => {
          this.boundChangedDisabled ? this.lastCenterChecked.centers = [this.getCenter()] : this.lastCenterChecked.centers[1] = this.getCenter();
        }), this.addEventListener(this.realmap, Z.idle, () => {
          if (this.lastCenterChecked.centers.length > 1) {
            const [e, i] = this.getCenter(),
              n = this.handleBoundsChanged.bind(this);
            setTimeout(() => {
              const t = this.getCenter(),
                [r, s] = t;
              if (r === e && s === i) {
                this.lastCenterChecked.centers = [t];
                const e = this.lastCenterChecked.events.splice(0, this.lastCenterChecked.events.length),
                  i = this.keyboardListeners.extractKeyboardEvent("center_changed");
                b(i).forEach(n), b(e).forEach(n);
              }
            }, t);
          }
        })];
      }
      _registerZoomListener() {
        const {
            debouncingEventsTime: e
          } = this.settings.googleMaps,
          t = e.zoomChanged;
        return [this.addEventListener(this.realmap, Z.mapZoomChanged, () => {
          this.boundChangedDisabled ? this.lastZoomValueChecked = [this.getZoom()] : this.lastZoomValueChecked[1] = this.getZoom();
        }), this.addEventListener(this.realmap, Z.idle, () => {
          if (this.lastZoomValueChecked.length > 1) {
            const e = this.getZoom(),
              i = this.handleBoundsChanged.bind(this);
            setTimeout(() => {
              const t = this.getZoom();
              if (t === e) {
                const [e] = this.lastZoomValueChecked,
                  n = t > e;
                this.lastZoomValueChecked = [t];
                const r = this.keyboardListeners.extractKeyboardEvent("zoom_changed");
                r.length > 0 ? b(r).forEach(i) : n ? this.handleBoundsChanged("zoomIn") : this.handleBoundsChanged("zoomOut");
              }
            }, t);
          }
        })];
      }
      _createCallbackForBoundsChanged(e) {
        const t = this.handleBoundsChanged.bind(this);
        return () => t(e);
      }
      centerAndZoomMap(e, t, i) {
        let [n, r] = e ? k(e) : [],
          s = t ? C(t) : void 0;
        if (void 0 !== n && void 0 !== r && void 0 !== s && void 0 !== i) {
          const t = this._parseClientPadding(i),
            {
              zoom: o,
              center: a
            } = this._getPaddedZoomAndCenterForCenterAndZoom(e, s, t) || {};
          void 0 !== o && void 0 !== a && ([n, r] = a, s = o);
        }
        const o = this.realmap.getCenter(),
          [a, l] = k([o.lat(), o.lng()]) || [];
        let h = void 0 !== n && void 0 !== r && (a !== n || l !== r) || void 0 !== s && this.getZoom() !== s;
        return h && this._fitViewport(s, [n, r], !1).then(this._updateViewport.bind(this)), h;
      }
      isFeatureInRealBound(e, t) {
        return null == e ? void 0 : e.contains({
          lat: t.latLng[0],
          lng: t.latLng[1]
        });
      }
      asNativeBounds(e, t) {
        let i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
        return new google.maps.LatLngBounds(new google.maps.LatLng(M(e[0]), M(e[1], void 0, i)), new google.maps.LatLng(M(t[0]), M(t[1], void 0, i)));
      }
      getCenter() {
        const e = this.realmap.getCenter();
        return [M(e.lat()), M(e.lng())];
      }
      getZoom() {
        return C(this.realmap.getZoom());
      }
      unbindAll() {
        this.listenersToDeregister.forEach(e => e()), this.customMarkerOverlay && this.customMarkerOverlay.unbindAll(), this.realmap.unbindAll(), super.unbindAll();
      }
      asBounds(e) {
        if (e) {
          const t = e.getSouthWest(),
            i = e.getNorthEast(),
            n = this.getCenter();
          return {
            sw: [M(t.lat()), M(t.lng())],
            ne: [M(i.lat()), M(i.lng())],
            center: n
          };
        }
      }
      containerBounds(e) {
        if (this.customMarkerOverlay) {
          const t = this.customMarkerOverlay.getProjection();
          if (t) {
            const i = t.fromContainerPixelToLatLng(new google.maps.Point(e.offsetLeft - e.offsetWidth / 2, e.offsetTop + e.offsetHeight / 2)),
              n = t.fromContainerPixelToLatLng(new google.maps.Point(e.offsetLeft + e.offsetWidth / 2, e.offsetTop - e.offsetHeight / 2));
            return {
              sw: [M(i.lat()), M(i.lng())],
              ne: [M(n.lat()), M(n.lng())],
              center: [M(i.lat() + (i.lat() - n.lat()) / 2), M(n.lng() + (n.lng() - i.lng()) / 2)]
            };
          }
        }
      }
      _boundsForOneCoordinate(e) {
        return e.getNorthEast().equals(e.getSouthWest());
      }
      _extendsOneCoordinateBounds(e) {
        let t = new google.maps.LatLng(e.getNorthEast().lat() + .01, e.getNorthEast().lng() + .01),
          i = new google.maps.LatLng(e.getNorthEast().lat() - .01, e.getNorthEast().lng() - .01);
        e.extend(t), e.extend(i);
      }
      computeNativeBoundsFromLatLongs(e) {
        if (e.length > 0) {
          let t = new google.maps.LatLngBounds();
          return e.forEach(e => {
            const [i, n] = k(e);
            t.extend(new google.maps.LatLng(i, n));
          }), t;
        }
      }
      fitLatLongs(e) {
        let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
          i = arguments.length > 2 ? arguments[2] : void 0;
        if (this.realmap) {
          const n = this._parseClientPadding(i),
            {
              zoom: r,
              center: s
            } = this._getPaddedZoomAndCenterFromLatLongs(e, t, n) || {};
          if (void 0 !== r && void 0 !== s) {
            const e = this._updateViewport.bind(this),
              t = this.asBounds.bind(this);
            return this._fitViewport(r, s).then(e).then(t);
          }
          return Promise.resolve(this.getBounds());
        }
        return Promise.reject("map is not ready");
      }
      nativeBounds() {
        var e, t;
        return (null === (e = this.customMarkerOverlay) || void 0 === e || null === (e = e.getProjection()) || void 0 === e || null === (e = e.getVisibleRegion()) || void 0 === e ? void 0 : e.latLngBounds) || (null === (t = this.realmap) || void 0 === t ? void 0 : t.getBounds());
      }
      switchMarkerType(e, t) {
        super.switchMarkerType(e, t) && this.customMarkerOverlay && this._updateMarkerPositionOnLayer(e, this.customMarkerOverlay.getProjection());
      }
      onMarkerIconsChanged(e) {
        this._updateMarkerPositionOnLayer(e, this.customMarkerOverlay.getProjection());
      }
      _fitViewport(e, t) {
        if (void 0 !== e || t) {
          const {
              fitBoundsAnimTime: i
            } = this.settings.googleMaps,
            n = i || 500,
            [r, s] = this.getCenter(),
            o = {
              tilt: 0,
              heading: 0,
              zoom: this.getZoom(),
              center: {
                lat: r,
                lng: s
              }
            },
            [h, d] = t,
            u = {
              zoom: e,
              center: {
                lat: h,
                lng: d
              }
            },
            c = this;
          a.Geo.areLongitudesCrossingDateLine([s, d]) && (s < 0 ? o.center.lng += 360 : o.center.lng -= 360);
          const p = this.addEventListener.bind(this),
            m = () => new Promise(e => {
              new g(o).to(u, n).easing(l.Exponential.Out).onUpdate(() => {
                let e = o;
                o.center.lng < -180 ? e = {
                  zoom: o.zoom,
                  center: {
                    lat: o.center.lat,
                    lng: o.center.lng + 360
                  }
                } : o.center.lng > 180 && (e = {
                  zoom: o.zoom,
                  center: {
                    lat: o.center.lat,
                    lng: o.center.lng - 360
                  }
                }), c.boundChangedDisabled = !0, c.realmap.moveCamera(e);
              }).onComplete(() => {
                p(c.realmap, Z.idle, () => {
                  c.boundChangedDisabled = !1, e();
                }, !0);
              }).start(), requestAnimationFrame(function e(t) {
                requestAnimationFrame(e), v(t);
              });
            });
          return this.idle ? m() : new Promise(e => p(this.realmap, Z.idle, () => m().then(e), !0));
        }
        return Promise.resolve();
      }
      _zoomAndCenterFromViewport(e, t) {
        if (e) {
          const {
              center: i,
              zoom: n,
              sw: r,
              ne: s,
              coordinates: o,
              useBoundsComputation: a,
              options: l
            } = e,
            h = this._parseClientPadding(t);
          if (i && n) return this._getPaddedZoomAndCenterForCenterAndZoom(i, n, h);
          if (r && s) {
            const e = k(r),
              t = k(s);
            return this._getPaddedZoomAndCenterForBounds(e, t, !1, h);
          }
          if (o && a) {
            const e = this._computeNativeBounds(o, a, l),
              {
                zoom: t,
                center: i
              } = this._computeZoomAndCenterFromGmapsBounds(e, !1, h) || {};
            if (t && i) return P(t, i, h);
          } else if (L(e) && e.length > 0) return this._getPaddedZoomAndCenterFromLatLongs(e, !0, h);
        }
      }
      _getPaddedZoomAndCenterForCenterAndZoom(e, t, i) {
        return P(t, e, i);
      }
      _getPaddedZoomAndCenterForBounds(e, t, i, n) {
        let r = new google.maps.LatLngBounds(new google.maps.LatLng(e[0], e[1]), new google.maps.LatLng(t[0], t[1]));
        const {
          zoom: s,
          center: o
        } = this._computeZoomAndCenterFromGmapsBounds(r, i, n) || {};
        if (s && o) return P(s, o, n);
      }
      _getPaddedZoomAndCenterFromLatLongs(e, t, i) {
        const {
          zoom: n,
          center: r
        } = this._computeZoomAndCenterFromGmapsBounds(this.computeNativeBoundsFromLatLongs(this.boundsComputation.computeBoundingBox(e)), t, i) || {};
        if (n && r) return P(n, r, i);
      }
      _computeZoomAndCenterFromGmapsBounds(e) {
        let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
          i = arguments.length > 2 ? arguments[2] : void 0,
          n = e;
        this._boundsForOneCoordinate(n) && (n = new google.maps.LatLngBounds(n.getSouthWest(), n.getNorthEast()), this._extendsOneCoordinateBounds(n));
        const {
            padding: r
          } = this.settings.googleMaps,
          s = w(this.node, n.getSouthWest().lat(), n.getSouthWest().lng(), n.getNorthEast().lat(), n.getNorthEast().lng(), {
            zoomMax: 21,
            padding: t ? r : 0,
            parsedClientPadding: i
          });
        if (isFinite(s)) return {
          zoom: s,
          center: k([n.getCenter().lat(), n.getCenter().lng()])
        };
      }
      getTileDim() {
        return {
          width: N,
          height: R
        };
      }
      fitBounds(e, t) {
        let i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
          n = arguments.length > 3 ? arguments[3] : void 0;
        if (this.realmap) {
          const r = this._parseClientPadding(n),
            s = k(e),
            o = k(t),
            {
              zoom: a,
              center: l
            } = this._getPaddedZoomAndCenterForBounds(s, o, i, r) || {};
          if (void 0 !== a && void 0 !== l) {
            const e = this.getZoom(),
              [t, i] = this.getCenter();
            if (t !== l[0] || i !== l[1] || e !== a) {
              const e = this._updateViewport.bind(this),
                t = this.asBounds.bind(this);
              return this._fitViewport(a, l).then(e).then(t);
            }
          }
          return Promise.resolve(this.getBounds());
        }
        return Promise.reject("map is not ready");
      }
      addEventListener(e, t, i) {
        let n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
        if (this._isAdvancedMarkerApiLoaded() && e instanceof google.maps.marker.AdvancedMarkerElement) {
          if (t === D.mouseEnter || t === D.mouseLeave || t === D.keyPress) {
            var r;
            const s = null === (r = e.content) || void 0 === r ? void 0 : r.parentNode,
              o = "GMP-ADVANCED-MARKER" === a.HtmlUtils.getTagName(s) ? s : s.parentNode;
            return o ? this._addEventListener(o, t, i, n) : () => 0;
          }
          if (n) {
            const e = "https://developers.google.com/maps/documentation/javascript/reference/advanced-markers#AdvancedMarkerElement.addEventListener";
            return this.logger.error(`Adding one time listener ${t} on advanced google maps marker is not supported yet.\n          Check when method comp.addEventListener() will be officially released on ${e}.`), () => 0;
          }
          {
            const n = e.addListener(t, i);
            return () => n.remove();
          }
        }
        return e instanceof google.maps.Polygon || e instanceof google.maps.Map || Object.values(Z).includes(t) ? this._addGoogleMapsEventListener(e, t, i, n) : this._addEventListener(e, t, i, n);
      }
      _addEventListener(e, t, i) {
        let n = arguments.length > 4 ? arguments[4] : void 0;
        return arguments.length > 3 && void 0 !== arguments[3] && arguments[3] ? e.addEventListenerOnce(t, i, n) : e.addEventListener(t, i, n), () => e.removeEventListener(t, i);
      }
      _addGoogleMapsEventListener(e, t, i) {
        let n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3] ? google.maps.event.addListenerOnce(e, t, i) : google.maps.event.addListener(e, t, i);
        return () => google.maps.event.removeListener(n);
      }
      _createPopup() {
        const e = this._createGenericPopup(this._getMainParent());
        a.HtmlUtils.setDisplayNone(e), e.zIndexElement = e, e.visibleElement = e, e.cssElement = e, e.listening = e, e.clean = B(e.listening, !1, () => e.feature, this.settings, this.getEventManagementMethods());
        const {
          maxZIndex: t
        } = this.settings;
        return j(e, t + 1), e;
      }
      _createDebugMarker(e) {
        return this.settings.debugMarkersPosition ? {
          debug: new google.maps.Marker({
            position: new google.maps.LatLng(e.latLng[0], e.latLng[1]),
            map: this.realmap
          }),
          style: "opacity: 0.5"
        } : {};
      }
      _clearObfuscateArea(e) {
        const {
          obfuscateArea: t
        } = e;
        t && (t.setMap(null), delete e.obfuscateArea);
      }
      _createClickableObfuscatedPolygon(e, t) {
        return this._createObfuscatedPolygon(e, t, !0);
      }
      _createNonClickableObfuscatedPolygon(e, t) {
        return this._createObfuscatedPolygon(e, t, !1);
      }
      _createObfuscatedPolygon(e, t, i) {
        const n = this.getCirclePolygonData(t),
          r = new google.maps.Polygon({
            paths: n,
            map: this.realmap.data.getMap(),
            clickable: i
          });
        return e.obfuscateArea = r, this._updateObfuscateAreaStyle(t, r), r;
      }
      _updateObfuscateAreaStyle(e, t) {
        var i, n, r, s, o;
        const {
          key: a,
          value: l
        } = y(this.settings.obfuscateStyle[e.type], e.hashKeys);
        t.setOptions({
          fillColor: null == l || null === (i = l.fill) || void 0 === i ? void 0 : i.color,
          fillOpacity: null == l || null === (n = l.fill) || void 0 === n ? void 0 : n.opacity,
          strokeColor: null == l || null === (r = l.line) || void 0 === r ? void 0 : r.color,
          strokeOpacity: null == l || null === (s = l.line) || void 0 === s ? void 0 : s.opacity,
          strokeWeight: null == l || null === (o = l.line) || void 0 === o ? void 0 : o.weight
        }), t.styleKey = a;
      }
      hasObfuscatedAreaStyleChanged(e) {
        var t, i;
        return (null === (t = e.marker) || void 0 === t ? void 0 : t.obfuscateArea) && (null === (i = e.marker) || void 0 === i || null === (i = i.obfuscateArea) || void 0 === i ? void 0 : i.styleKey) !== _(this.settings.obfuscateStyle[e.type], e.hashKeys);
      }
      _getMainParent() {
        var e;
        return (null === (e = this.customMarkerOverlay) || void 0 === e || null === (e = e.getPanes()) || void 0 === e ? void 0 : e.overlayMouseTarget) || this.temporaryDiv;
      }
      stopPropagation(e) {
        e.stopPropagation && e.stopPropagation(), e.stop && e.stop();
      }
      getEventManagementMethods() {
        return {
          addEventListener: this.addEventListener.bind(this),
          stopPropagation: this.stopPropagation.bind(this),
          handleClick: this.handleClick.bind(this),
          handleMouseOver: this.handleMouseOver.bind(this),
          handleMouseOut: this.handleMouseOut.bind(this),
          handleKeyPress: this.handleKeyPress.bind(this)
        };
      }
      _createMarkerOnMap(e, t, i) {
        const [n, r] = t,
          s = this.useAdvancedMarkers ? new google.maps.marker.AdvancedMarkerElement({
            position: new google.maps.LatLng(n, r),
            map: this.realmap,
            content: e.content,
            collisionBehavior: google.maps.CollisionBehavior.REQUIRED_AND_HIDES_OPTIONAL
          }) : e.content;
        return this.useAdvancedMarkers ? (e.advancedMarker = !0, e.ariaElement = s, delete e.zIndexElement, i || (e.listening = s)) : e.position = new google.maps.LatLng(n, r), s;
      }
      createPinMarker(e, t, i) {
        return this._createPinMarker(e, t, i);
      }
      createPinObfuscatedMarker(e, t, i) {
        return this._createPinMarker(e, t, i, this._createNonClickableObfuscatedPolygon.bind(this));
      }
      _getMarkerParent() {
        return this.useAdvancedMarkers ? void 0 : this._getMainParent();
      }
      _switchAriaLabel(e, t, i) {
        if (t.advancedMarker) {
          const n = t.ariaElement;
          i && (e && i.onSelect ? n.title = i.onSelect : i.default ? n.title = i.default : delete n.title);
        } else U(e, t, i);
      }
      _createPinMarker(e, t, i, n) {
        const {
            feature: r
          } = e,
          {
            debug: s,
            style: o
          } = this._createDebugMarker(r),
          a = this.uniqId(`marker-${this.asKey(r)}`);
        this.useAdvancedMarkers || e.cssClasses.push("dom-marker");
        const l = T(a, e, this._getMarkerParent(), t, i, o, this.settings, n);
        l.debug = s;
        const h = this._createMarkerOnMap(l, r.latLng);
        return x(h, l, e, this.settings, this.getEventManagementMethods(), this._switchAriaLabel.bind(this)), h;
      }
      createTextMarker(e, t, i) {
        return this._createTextMarker(e, t, i);
      }
      createPriceObfuscatedMarker(e, t) {
        return this._createTextMarker(e, t, "price", this._createNonClickableObfuscatedPolygon.bind(this));
      }
      _createTextMarker(e, t, i, n) {
        const {
            feature: r
          } = e,
          {
            debug: s,
            style: o
          } = this._createDebugMarker(r),
          a = this.uniqId(`marker-${this.asKey(r)}`);
        this.useAdvancedMarkers || e.cssClasses.push("dom-marker");
        const l = A(a, e, this._getMarkerParent(), t, i, o, this.settings, n);
        l.debug = s;
        const h = this._createMarkerOnMap(l, r.latLng);
        return x(h, l, e, this.settings, this.getEventManagementMethods(), this._switchAriaLabel.bind(this)), h;
      }
      createClusterMarker(e) {
        const {
            featureType: t,
            qualifier: i
          } = e,
          n = this.uniqId(`marker-${t}-cluster-${e.id}`),
          {
            debug: r,
            style: s
          } = this._createDebugMarker(e),
          o = S(n, this._getMarkerParent(), e, t, i, s);
        this.useAdvancedMarkers || a.HtmlUtils.addClass(o.content, "dom-marker"), o.debug = r;
        const l = this._createMarkerOnMap(o, e.latLng),
          {
            zIndexes: h
          } = this.settings,
          d = f(h[e.type], e.hashKeys),
          u = {
            default: e.text,
            onSelect: e.text
          };
        return x(l, o, {
          feature: e,
          zIndex: d,
          ariaLabels: u
        }, this.settings, this.getEventManagementMethods(), this._switchAriaLabel.bind(this)), l;
      }
      createObfuscatedMarker(e) {
        const {
            feature: t
          } = e,
          {
            debug: i,
            style: n
          } = this._createDebugMarker(t),
          r = this.uniqId(`marker-${this.asKey(t)}`);
        this.useAdvancedMarkers || e.cssClasses.push("dom-marker");
        const s = F(r, e, this._getMarkerParent(), n, this.settings, this._createClickableObfuscatedPolygon.bind(this));
        s.debug = i;
        const o = this._createMarkerOnMap(s, t.latLng, !0);
        return x(o, s, e, this.settings, this.getEventManagementMethods(), this._switchAriaLabel.bind(this)), o;
      }
      resetRouteStyle() {}
      _createPolyline(e, t, i) {
        const n = {
          path: e,
          geodesic: null != i && i
        };
        switch (t.lineStyle) {
          case "none":
            break;
          case "dash":
            n.icons = [{
              icon: {
                path: "M 0,-1 0,1",
                fillColor: t.color,
                fillOpacity: t.opacity,
                strokeColor: t.color,
                strokeOpacity: t.opacity,
                scale: t.width
              },
              offset: "0",
              repeat: 4 * t.width + "px"
            }], n.strokeOpacity = 0;
            break;
          case "dot":
            n.icons = [{
              icon: {
                path: google.maps.SymbolPath.CIRCLE,
                fillColor: t.color,
                fillOpacity: t.opacity,
                strokeColor: t.color,
                strokeOpacity: t.opacity,
                scale: t.width / 2
              },
              offset: "0",
              repeat: 2 * t.width + "px"
            }], n.strokeOpacity = 0;
            break;
          default:
            n.strokeColor = t.color, n.strokeWeight = t.width, n.strokeOpacity = t.opacity;
        }
        return new google.maps.Polyline(n);
      }
      addRouteOnMap(e, t) {
        return new Promise(i => {
          var n;
          null === (n = t.route) || void 0 === n || delete n.copyrights;
          const r = "flying" == e.mode;
          e.polyline = this._createPolyline(t.route.path, this.settings.routeLineStyleByDistanceMode[e.mode], r), e.polyline.setMap(this.realmap), i(e);
        });
      }
      removeRouteOnMap(e) {
        return new Promise(t => {
          var i;
          null === (i = e.polyline) || void 0 === i || i.setMap(null), t();
        });
      }
      addPolygonsOnMap(e) {
        const t = e.map(e => {
          let {
            polygonDisplayed: t,
            style: i
          } = e;
          const {
              id: n,
              type: r,
              polygon: s
            } = t,
            o = this._createPolygon(s, i);
          o.forEach(e => e.setMap(this.realmap));
          const a = {
              id: n,
              type: r
            },
            l = this.asKey(a);
          return this.visiblePolygonsByKey.set(l, o), a;
        });
        return Promise.resolve(t);
      }
      removePolygonsOnMap(e) {
        const t = e.map(e => {
          const t = this.asKey(e),
            i = this.visiblePolygonsByKey.get(t);
          if (i) return i.forEach(e => e.setMap(null)), this.visiblePolygonsByKey.delete(t), e;
        }).filter(e => void 0 !== e);
        return Promise.resolve(t);
      }
      _createPolygon(e, t) {
        return E(e).map(e => {
          const i = {
            clickable: !1,
            paths: 1 === e.length ? e[0] : e,
            strokeColor: t.line.color,
            strokeOpacity: t.line.opacity,
            strokeWeight: t.line.weight,
            fillColor: t.fill.color,
            fillOpacity: t.fill.opacity
          };
          return new google.maps.Polygon(i);
        });
      }
      forceMapModeView() {
        var e;
        null === (e = this.realmap) || void 0 === e || null === (e = e.getStreetView()) || void 0 === e || e.setVisible(!1);
      }
    }
    const {
        timeoutFetch: H
      } = a.BrowserUtils,
      {
        removeDuplicates: K
      } = a.Utils;
    function G(e) {
      return "string" == typeof e ? e.replace(/^((google([-_]?maps)?|googlemaps)[_-]?)/, "") : e;
    }
    class W {
      constructor(e, t, i, n) {
        this.contentProviderName = e, this.logger = t, this.locale = i, this.config = n;
      }
      isValid() {
        var e;
        return void 0 !== this.config && (null === (e = this.config.fields) || void 0 === e ? void 0 : e.length) > 0 && ("rest" !== this.config.callType || void 0 !== this.config.restUrl && void 0 !== this.config.restKey);
      }
      _fetchPhotos(e) {
        return new Promise(t => {
          var i;
          return a.BrowserUtils.promiseAllSettled(((null === (i = e.additionalContent) || void 0 === i ? void 0 : i.photos) || []).map(e => this._newFetchPhotoFromUriCallback(e)())).then(() => t());
        });
      }
      _newFetchPhotoFromUriCallback(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : H;
        const {
          restPhotoUrl: i,
          restKey: n,
          restPhotoTimeout: r,
          maxWidthPx: s,
          maxHeightPx: o
        } = this.config;
        return (a, l, h) => new Promise(d => {
          if (!e.photoUri) {
            const u = ["skipHttpRedirect=true"],
              c = a || s;
            c && u.push(`maxWidthPx=${c}`);
            const p = l || o;
            p && u.push(`maxHeightPx=${p}`);
            const g = `${i}${e.name}/media?${u.join("&")}`;
            return t(g, h || r, {
              headers: {
                "Content-Type": "application/json",
                "X-Goog-Api-Key": n
              }
            }).then(t => {
              t.ok ? t.json().then(t => {
                e.photoUri = t.photoUri, d(e.photoUri);
              }) : (t.text().then(e => this.logger.warn(`Get photo url from ${g} is not returning OK`, e)), d(void 0));
            }).catch(e => {
              this.logger.warn(`Failed to get photo url from ${g}`, e), d(void 0);
            });
          }
          d(e.photoUri);
        });
      }
      loadContent(e) {
        var t;
        if (null !== (t = e.additionalContent) && void 0 !== t && null !== (t = t.origins) && void 0 !== t && t.includes("GooglePlacesApi")) return Promise.resolve();
        const {
          callType: i
        } = this.config;
        return "library" === i ? this._loadContentFromLibrary(e) : this._loadContentFromRest(e).then(e => {
          const {
            photos: t
          } = this.config;
          return "json" === t ? this._fetchPhotos(e) : (((null === (i = e.additionalContent) || void 0 === i ? void 0 : i.photos) || []).forEach(e => {
            e.getPhotoUri = this._newFetchPhotoFromUriCallback(e);
          }), Promise.resolve());
          var i;
        }).then(() => e);
      }
      _extractText(e) {
        if (e) {
          if ("string" == typeof e) return e;
          if ("object" == typeof e && e.text) return e.text;
        }
      }
      _fillPlaceWithGooglePlaceData(e, t) {
        var i, n;
        e.name = this._extractText(null !== (i = t.displayName) && void 0 !== i ? i : t.name), e.description = this._extractText(t.primaryTypeDisplayName), e.ariaLabels = {
          default: `${e.name}${e.description ? `, ${e.description}` : ""}`
        }, e.additionalContent || (e.additionalContent = {}), e.additionalContent.origins || (e.additionalContent.origins = []), e.additionalContent.origins.push("GooglePlacesApi"), e.qualifiers = K([...(e.qualifiers || []), `from-${this.contentProviderName}`]), null === (n = this.config) || void 0 === n || n.fields.forEach(i => {
          "photos" === i ? this._fillPhotos(e, t[i]) : e.additionalContent[i] = t[i];
        });
      }
      _fillPhotos(e, t) {
        const {
            maxPhotos: i
          } = this.config,
          n = i ? t.slice(0, i) : t;
        e.additionalContent.photos = n;
      }
      _loadContentFromLibrary(e) {
        return new Promise(t => {
          var i;
          const n = G(e.id),
            r = new google.maps.places.Place({
              id: n,
              requestedLanguage: this.locale
            });
          r.fetchFields({
            fields: null === (i = this.config) || void 0 === i ? void 0 : i.fields
          }).then(() => {
            this._fillPlaceWithGooglePlaceData(e, r), t(e);
          }).catch(i => {
            this.logger.warn(`Failed to fetch content for the place id ${n} from google places library`, i), t(e);
          });
        });
      }
      _loadContentFromRest(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : H;
        const {
            restUrl: i,
            restKey: n,
            fields: r,
            restContentTimeout: s = 1e3
          } = this.config,
          [o, a] = this.locale.split("-"),
          l = [];
        l.push(`languageCode=${o.toLowerCase()}`), a && l.push(`regionCode=${a.toLowerCase()}`);
        const h = {
            "Content-Type": "application/json",
            "X-Goog-Api-Key": n,
            "X-Goog-FieldMask": r.join(",")
          },
          d = G(e.id);
        return t(`${i}${d}?${l.join("&")}`, s, {
          headers: h
        }).then(t => t.ok ? t.json().then(t => (this._fillPlaceWithGooglePlaceData(e, t), e)) : (t.text().then(e => this.logger.warn(`Failed to fetch content for the place id ${d} from google places REST api`, e)), e)).catch(t => (this.logger.warn(`Failed to fetch content for the place id ${d} from google places REST api`, t), e));
      }
    }
    function $(e, t) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), i.push.apply(i, n);
      }
      return i;
    }
    function q(e) {
      for (var t = 1; t < arguments.length; t++) {
        var i = null != arguments[t] ? arguments[t] : {};
        t % 2 ? $(Object(i), !0).forEach(function (t) {
          X(e, t, i[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : $(Object(i)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
        });
      }
      return e;
    }
    function X(e, t, i) {
      return (t = function (e) {
        var t = function (e, t) {
          if ("object" != typeof e || !e) return e;
          var i = e[Symbol.toPrimitive];
          if (void 0 !== i) {
            var n = i.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
      }(t)) in e ? Object.defineProperty(e, t, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = i, e;
    }
    return ("undefined" != typeof window ? window : n.g).egmapsGoogleMaps = q(q({}, r), s), {};
  }();
});